import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../utils/axiosInstance";
import "./AdminUpload.css"; // Optional: style file

const AdminUploadVideo = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [requiredPlan, setRequiredPlan] = useState("free");
  const [isAuthorized, setIsAuthorized] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user && user.id === 1) {
      setIsAuthorized(true);
    } else {
      alert("Access Denied: Only Admin can upload videos.");
      navigate("/dashboard");
    }
  }, [navigate]);

  const handleUpload = async (e) => {
    e.preventDefault();

    if (!file) return alert("Please select a video file");

    const formData = new FormData();
    formData.append("title", title);
    formData.append("description", description);
    formData.append("video", file);
    formData.append("required_plan", requiredPlan); // ✅ required plan sent to backend

    try {
      await API.post("/videos/upload", formData);
      alert("Video uploaded successfully!");
      setTitle("");
      setDescription("");
      setFile(null);
      setRequiredPlan("free");
    } catch (error) {
      console.error("Upload failed:", error);
      alert("Video upload failed.");
    }
  };

  if (!isAuthorized) return <p>Unauthorized</p>;

  return (
    <div className="upload-container">
      <h4>Upload Video</h4>
      <form onSubmit={handleUpload}>
        <input
          type="text"
          placeholder="Video Title"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          required
        />

        <textarea
          placeholder="Video Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          required
        ></textarea>

        <select
          value={requiredPlan}
          onChange={(e) => setRequiredPlan(e.target.value)}
          required
        >
          <option value="free">Free</option>
          <option value="premium">Premium</option>
          <option value="pro">Pro</option>
        </select>

        <input
          type="file"
          accept="video/mp4"
          onChange={(e) => setFile(e.target.files[0])}
          required
        />

        <button type="submit">Upload</button>
      </form>
    </div>
  );
};

export default AdminUploadVideo;
